import { useState, useEffect } from "react"
import AppLayout from "../../components/layout/AppLayout"
import ProfileTab from "../../components/settings/ProfileTab"
import OrganizationsTab from "../../components/settings/OrganizationsTab"
import MembersTab from "../../components/settings/MembersTab"
import AccountsTab from "../../components/settings/AccountsTab"
import PermissionsTab from "../../components/settings/PermissionsTab"
import { useSelectedAccount } from "../../contexts/AccountContext"
import { PAGE_TITLES } from "../../lib/navItems"
import "../../styles/settings.scss"

type Tab = "profile" | "organizations" | "members" | "accounts" | "permissions"

const ALL_TABS: { id: Tab; icon: string; label: string }[] = [
  { id: "profile", icon: "bi-person", label: "プロフィール" },
  { id: "organizations", icon: "bi-building", label: "組織管理" },
  { id: "members", icon: "bi-people", label: "メンバー管理" },
  { id: "accounts", icon: "bi-instagram", label: "アカウント管理" },
  { id: "permissions", icon: "bi-shield-lock", label: "権限設定" },
]

const getInitialTab = (): Tab => {
  const params = new URLSearchParams(window.location.search)
  const tab = params.get("tab")
  if (tab === "accounts" || tab === "members" || tab === "organizations" || tab === "permissions") return tab
  return "profile"
}

const OWNER_ONLY_TABS: Tab[] = ["members", "accounts", "permissions"]

const SettingsPage = () => {
  const { selectedOrganizationRole } = useSelectedAccount()
  const [activeTab, setActiveTab] = useState<Tab>(getInitialTab)

  const tabs = selectedOrganizationRole === "owner"
    ? ALL_TABS
    : ALL_TABS.filter(t => t.id === "profile" || t.id === "organizations")

  // オーナー専用タブを表示中に組織切り替えでメンバーになった場合は組織管理へ退避
  // null はロード中を意味するため、確定値が来るまで切り替えない
  useEffect(() => {
    if (selectedOrganizationRole !== null && selectedOrganizationRole !== "owner" && OWNER_ONLY_TABS.includes(activeTab)) {
      setActiveTab("organizations")
    }
  }, [selectedOrganizationRole, activeTab])

  return (
    <AppLayout pageTitle={PAGE_TITLES["/settings"]}>
      <div className="settings">
        <nav className="settings-tabs">
          {tabs.map(({ id, icon, label }) => (
            <button
              key={id}
              className={`settings-tabs__item${activeTab === id ? " settings-tabs__item--active" : ""}`}
              onClick={() => setActiveTab(id)}
            >
              <i className={`bi ${icon}`} />
              <span>{label}</span>
            </button>
          ))}
        </nav>

        <div className="settings-content">
          {activeTab === "profile" && <ProfileTab />}
          {activeTab === "organizations" && <OrganizationsTab />}
          {activeTab === "members" && <MembersTab />}
          {activeTab === "accounts" && <AccountsTab />}
          {activeTab === "permissions" && <PermissionsTab />}
        </div>
      </div>
    </AppLayout>
  )
}

export default SettingsPage
